module.exports = {"150822100":"巴彦高勒镇","150822101":"隆盛合镇","150822102":"渡口镇","150822103":"补隆淖镇","150822200":"沙金套海苏木","150822400":"乌兰布和农场","150822401":"巴彦套海农场","150822402":"哈腾套海农场","150822403":"包尔盖农场","150822404":"纳林套海农场","150822405":"沙漠林业实验中心农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150822.json
// module id = 415
// module chunks = 0